import {createAction} from '@reduxjs/toolkit'

import {AdStatusType} from '../interfaces'

export const updateAdStatus = createAction<AdStatusType>('recommendationProduct/updateAdStatus')
